import { createSelector } from '@ngrx/store';
import { historyOrdersState } from '../root';

export const getHistoryOrdersState = createSelector(historyOrdersState, (historyOrders) => historyOrders);
